<template>
<div style="width: 100%">
	<v-subheader>Workers</v-subheader>
	<v-card style="width: 100%">
		<v-data-table
				:headers="headers"
				:items="workersPayments"
				hide-actions
		>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.id }}</td>
				<td>{{ props.item.firstname }}</td>
				<td>{{ props.item.lastname }}</td>
				<td>{{ props.item.amount }}</td>
			</template>
		</v-data-table>
	</v-card>
</div>
</template>

<script>
import { HEADERS_TABLE_WORKER_REPORTS } from '../../constants'
import { localeHeadersWorkers } from '../../utils/helpers'

export default {
	data: vm => ({
		headers: localeHeadersWorkers(HEADERS_TABLE_WORKER_REPORTS, vm.$t)
	}),

	computed: {
		workersPayments() {
			return this.$store.state.reports.workersPayments
		}
	}
}
</script>
